import { createRadioOptionsHook } from "../hooks/create-radio-options-hook.js";
import { AudioTrackRadioGroupCore } from "@videojs/core";
import { selectAudioTrack } from "@videojs/core/dom";
//#region src/ui/audio-track/use-audio-track-options.ts
const useAudioTrackRadioOptions = createRadioOptionsHook({
	name: "useAudioTrackOptions",
	feature: "audioTrack",
	selector: selectAudioTrack,
	createCore: () => new AudioTrackRadioGroupCore()
});
/**
* Create audio track menu options from the player audio track state. Returns `null` when the audio track feature is not
* configured.
*
* @param props - Optional `label`, `formatTrack`, and `disabled` overrides.
*/
function useAudioTrackOptions(props) {
	"use no memo";
	return useAudioTrackRadioOptions(props);
}
//#endregion
export { useAudioTrackOptions };

//# sourceMappingURL=use-audio-track-options.js.map